



document.addEventListener('DOMContentLoaded', function() {
  var $div = $("#ModifPersoBlocBoutonStickATC"); 
  var divHeight = $div.outerHeight(true);

  $div.show();

  $(window).scroll(function() {
    var scrollTop = $(this).scrollTop(); 
    var windowHeight = $(this).height();
    var scrollPercent = (scrollTop / ($(document).height() - windowHeight)) * 100;

    if (scrollPercent >= 1 && scrollPercent <= 25) {
      $div.hide();
    } else {
      $div.show();      
    }
  });
});



document.addEventListener("DOMContentLoaded", function() {
    var variantPicker = document.querySelector('variant-picker');

    if (variantPicker) {
        var variantButtons = variantPicker.querySelectorAll('.popover-listbox__option');
        variantButtons.forEach(function(button) {
            button.addEventListener('click', updateVariantImage);
        });

        function updateVariantImage() {
            var selectedOptions = Array.from(variantPicker.querySelectorAll('input[type="hidden"]')).map(function(input) {
                return input.value;
            });
            var productHandle = variantPicker.getAttribute('handle');

            fetch('/products/' + productHandle + '.js')
                .then(response => response.json())
                .then(product => {
                    var selectedVariant = product.variants.find(variant => {
                        return variant.options.every((option, index) => option === selectedOptions[index]);
                    });

                    if (selectedVariant && selectedVariant.featured_image) {
                        var variantImage = document.getElementById('variant-image');
                        if (variantImage) {
                            variantImage.src = selectedVariant.featured_image.src;
                            variantImage.alt = selectedVariant.title;
                        }
                    }
                })
                .catch(error => {
                    console.error('Error fetching product data:', error);
                });
        }
        // Initial update to set the correct image on page load
        updateVariantImage();
    }
});




document.addEventListener('DOMContentLoaded', function() {
    // Liste des champs du formulaire
    const formFields = [
      'emailAddress',
      'first_name',
      'last_name',
      'address_1',
      'address_2',
      'address_postal_code',
      'address_city',
      'address_country',
      'phone'
    ];

    // Charger les données depuis localStorage
    formFields.forEach(function(field) {
      const input = document.getElementById(field);
      if (input && localStorage.getItem(field)) {
        input.value = localStorage.getItem(field);
      }
    });

    // Sauvegarder les données dans localStorage lors de la saisie
    formFields.forEach(function(field) {
      const input = document.getElementById(field);
      if (input) {
        input.addEventListener('input', function() {
          localStorage.setItem(field, input.value);
        });
      }
    });
  });



function getCartCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

// Retourne la racine Shopify avec trailing slash (ex: "/" ou "/fr/")
function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root
        : '/';
}

// Fetch helper avec retry automatique en cas de 403 temporaire (Cloudflare / Shopify challenge)
async function fetchWithRetry(url, options = {}, maxAttempts = 3) {
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        try {
            const response = await fetch(url, { credentials: 'same-origin', ...options });
            if (response.status === 403 && attempt < maxAttempts) {
                await new Promise(resolve => setTimeout(resolve, 600 * attempt));
                continue;
            }
            return response;
        } catch (err) {
            if (attempt === maxAttempts) throw err;
            await new Promise(resolve => setTimeout(resolve, 600 * attempt));
        }
    }
}

async function fetchCartJS() {
    const response = await fetchWithRetry(shopifyRoot() + 'cart.js', {
        headers: { 'Accept': 'application/json' }
    });
    const data = await response.json();
    return data;
}

async function addProductToCart(product, quantity) {
    const response = await fetchWithRetry(shopifyRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: product,
            quantity: quantity || 1
        })
    });
    if (!response.ok) {
        let errorText = '';
        try {
            errorText = await response.text();
        } catch (_error) {}
        throw new Error(`Cart add failed for ${product}: HTTP ${response.status} ${errorText.slice(0, 120)}`);
    }
    return response;
}

async function clearCart() {
    const clearResponse = await fetchWithRetry(shopifyRoot() + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    });
    return clearResponse;
}

async function getCustomerIp(){
  const response = await fetch('https://api.ipify.org?format=json');
  const data = await response.json();
  return data.ip;
}

async function getProductMetaData(){
  const response = await fetch(`/cart?view=meta-data.json`);
  const data = await response.json();
  return data;
}

function generateHash(data, secretKey) {
  const hash = CryptoJS.SHA256(data + secretKey);
  return hash.toString(CryptoJS.enc.Hex);
}

function setSessionStorage(name, value, maxAge = null) {
  const data = {
    value: value,
    timestamp: Date.now()
  };
  if (maxAge !== null) {
    data.maxAge = maxAge * 1000; // Convertir en millisecondes
  }
  sessionStorage.setItem(name, JSON.stringify(data));
}

function getSessionStorage(name) {
  try {
    const item = sessionStorage.getItem(name);
    if (!item) return null;
    
    const data = JSON.parse(item);
    const now = Date.now();
    
    // Vérifier si l'élément a expiré
    if (data.maxAge && (now - data.timestamp) > data.maxAge) {
      sessionStorage.removeItem(name);
      return null;
    }
    
    return data.value;
  } catch (e) {
    console.warn('Erreur lors de la lecture du sessionStorage:', e);
    return null;
  }
}

function redirectPendingCartPermalinkToCheckout() {
  const pendingRedirect = getSessionStorage('pendingCartPermalinkCheckout');
  const isCartPage = window.location.pathname.replace(/\/+$/, '') === '/cart';

  if (!pendingRedirect || !isCartPage) {
    return;
  }

  sessionStorage.removeItem('pendingCartPermalinkCheckout');
  window.location.replace(pendingRedirect);
}

document.addEventListener('DOMContentLoaded', redirectPendingCartPermalinkToCheckout);

function parseLooseJSON(raw) {
  if (typeof raw !== 'string') return null;
  const text = raw.trim();
  if (!text) return null;
  try { return JSON.parse(text); } catch (_e) {}

  const start = text.search(/[\{\[]/);
  if (start < 0) return null;

  let depth = 0;
  let inString = false;
  let escaped = false;

  for (let i = start; i < text.length; i++) {
    const ch = text[i];

    if (inString) {
      if (escaped) { escaped = false; continue; }
      if (ch === '\\') { escaped = true; continue; }
      if (ch === '"') { inString = false; }
      continue;
    }

    if (ch === '"') { inString = true; continue; }
    if (ch === '{' || ch === '[') { depth++; continue; }
    if (ch === '}' || ch === ']') {
      depth--;
      if (depth === 0) {
        try { return JSON.parse(text.slice(start, i + 1)); } catch (_e2) { return null; }
      }
    }
  }

  return null;
}
async function getAccountCustomerData(email, orderId){
  try {
      const payload = {
          email: email.trim(),
          orderId: orderId.trim(),
          timestamp: Date.now()
      };

      const apiConfig = url_api_serveur();
      const response = await fetch(apiConfig.account_api, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
      });

      const text = await response.text();
      const sessionData = parseLooseJSON(text);
      if (!sessionData || typeof sessionData !== 'object') {
          return { error: 'Unexpected server response' };
      }
      
      if (sessionData && !sessionData.error) {
          const dataForSession = {
              data: sessionData,
              email: email,
              orderId: orderId,
              _ts: Date.now()
          };
          setSessionStorage('customerData', JSON.stringify(dataForSession));
          return dataForSession;
      }

      return sessionData;
      
  } catch (err) {
      console.error('Erreur getAccountCustomerData:', err);
      return { error: 'Erreur de connexion au serveur' };
  }
}

// Fonction utilitaire pour récupérer les pixels depuis la session
function getPixelConfigsFromSession() {
    const pixelString = getSessionStorage('pixel');
    if (!pixelString) {
        return [];
    }
    
    // Format: "pixelId:accessToken;pixelId2:accessToken2"
    const pixels = pixelString.split(';');
    return pixels.map(pixelPair => {
        const [pixelId, accessToken] = pixelPair.split(':');
        return { pixelId, accessToken };
    }).filter(config => config.pixelId && config.accessToken);
}



// Fonction pour corriger le nombre d'abonnements dans le panier
async function correctionNbAboDansLePanier(cartItems, subQuantity) {
  const variantId = 55905898889547;
  
  try {    
    const subscriptionItem = cartItems.find(item => item.id === variantId);
    if (!subscriptionItem) {
      return false;
    }

    const needsCorrection = (subQuantity === 0 && subscriptionItem.quantity > 0) || (subQuantity === 1 && subscriptionItem.quantity > 1);
    if (!needsCorrection) {
      return false;
    }

    // Vider le panier
    const clearResponse = await clearCart();
    if (!clearResponse.ok) {
      throw new Error(`Erreur lors du vidage du panier: ${clearResponse.status}`);
    }

    // Réajouter tous les produits sauf l'abonnement
    for (const item of cartItems) {
      if (item.id !== variantId) {
        const response = await addProductToCart(item.id, item.quantity);
        if (!response.ok) {
          console.error(`Erreur lors de l'ajout du produit ${item.id}`);
        }
      }
    }
    
    if (subQuantity === 1) {
      const response = await addProductToCart(variantId, 1);
      if (!response.ok) {
        console.error(`Erreur lors de l'ajout de l'abonnement`);
      }
    }
    
    return true;
  } catch (error) {
    console.error('Erreur lors de la correction du panier:', error);
    return false;
  }
}

async function verificationAbonnementActif(email) {
  const config = url_api_serveur();
  
  try {
    const response = await fetch(config.subscription_check_api, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'omit',
      body: JSON.stringify({
        email: email,
        timestamp: Date.now()
      })
    });
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erreur lors de la requête API :', error);
    return { success: false };
  }
}

function displayMessage(divMessage, type, text) {
  const divId = document.getElementById(divMessage);
  if (divId) {
    divId.className = 'form-message ' + type;
    //divId.textContent = text;
    if (typeof text === "object") {
      divId.textContent = Object.values(text).join("<br>");
    } else {
      divId.textContent = text;
    }
    divId.style.display = 'block';
    
    divId.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}

function hideMessage(messageDiv) {
  const divId = document.getElementById(messageDiv);
  if (divId) {
    divId.style.display = 'none';
  }
}

async function addAttributeToCart(attributesVariable, attributesValue) {
  try {    
    // Récupérer le formulaire du cart-drawer
    const form = document.getElementById('cart-form');
    if (!form) {
      console.error('Formulaire cart-form introuvable');
      return false;
    }
    
    // Chercher si un input avec ce nom existe déjà
    const existingInput = form.querySelector('input[name="attributes[' + attributesVariable + ']"]');
    
    if (existingInput) {
      // Si l'input existe déjà, mettre à jour sa valeur
      existingInput.value = attributesValue.toString();
    } else {
      // Sinon, créer un nouvel input
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[' + attributesVariable + ']';
      input.value = attributesValue.toString();
      form.appendChild(input);
    }
    
    // Soumettre le formulaire pour sauvegarder l'attribut
    const formData = new FormData(form);
    const response = await fetch('/cart', {
      method: 'POST',
      body: formData
    });
    
    if (response.ok) {
      return true;
    } else {
      console.error('Erreur lors de la sauvegarde de l\'attribut');
      return false;
    }
  } catch (error) {
    console.error('Erreur dans addAttributeToCart:', error);
    return false;
  }
}

async function saveShippingInfoToCart() {
  try {
    // Récupérer toutes les valeurs des champs de livraison
    const shippingData = {
      emailAddress: document.getElementById('emailAddress')?.value || '',
      first_name: document.getElementById('first_name')?.value || '',
      last_name: document.getElementById('last_name')?.value || '',
      address_1: document.getElementById('address_1')?.value || '',
      address_2: document.getElementById('address_2')?.value || '',
      address_postal_code: document.getElementById('address_postal_code')?.value || '',
      address_city: document.getElementById('address_city')?.value || '',
      address_country: document.getElementById('address_country')?.value || '',
      phone: document.getElementById('phone')?.value || '',
      shipProfileId: '41'
    };

    // Préparer les données pour la requête
    const formData = new FormData();
    
    // Ajouter tous les attributs de livraison
    Object.keys(shippingData).forEach(key => {
      if (shippingData[key].trim() !== '') {
        formData.append(`attributes[${key}]`, shippingData[key]);
      }
    });
    
    // Envoyer la requête pour sauvegarder tous les attributs en une fois
    const response = await fetch('/cart', {
      method: 'POST',
      body: formData
    });
    
  } catch (error) {
    console.error('Erreur dans saveShippingInfoToCart:', error);
    return false;
  }
}

// Helper : Arrête l'animation du bouton panier
function stopCartAnimation() {
  const cartBtn = document.querySelector('[type="submit"][name="cart"]');
  if (cartBtn) cartBtn.removeAttribute('aria-busy');
}

async function validateFields() {
  // Réinitialiser les erreurs
  const requiredInputs = document.querySelectorAll('.shipping-address-form input[required], .shipping-address-form select[required]');
  requiredInputs.forEach(input => {
    const errorClass = getErrorClass(input.id);
    const errorMessage = document.querySelector(`.${errorClass}`);
    if (errorMessage) errorMessage.classList.remove('showError');
    input.classList.remove('error');
  });

  const phoneErrorMessage = document.querySelector('.phoneError');
  if (phoneErrorMessage) phoneErrorMessage.classList.remove('showError');
  const validatePhone = document.querySelector('input#phone');
  if (validatePhone) validatePhone.classList.remove('error');

  const formData = {
    emailAddress: document.getElementById('emailAddress')?.value || '',
    first_name: document.getElementById('first_name')?.value || '',
    last_name: document.getElementById('last_name')?.value || '',
    address_1: document.getElementById('address_1')?.value || '',
    address_2: document.getElementById('address_2')?.value || '',
    address_postal_code: document.getElementById('address_postal_code')?.value || '',
    address_city: document.getElementById('address_city')?.value || '',
    address_country: document.getElementById('address_country')?.value || '',
    phone: document.getElementById('phone')?.value || '',
    isF: true,
    sessionId: getCartCookie('cart') || '' // Ajouter le cartId Shopify pour économiser les appels API
  };

  const localePrefix = getLocalePrefix();
  const language = localePrefix ? localePrefix.replace('/', '') : 'fr';
  if (language !== 'fr') {
    formData.language = language;
  }

  try {
    const config = url_api_serveur();
    const response = await fetch(config.customer_info_api, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });

    const data = await response.json();
    
    if (data.success) return true;
    
    if (data.showSuggestions && data.addressSuggestions) {
      return await handleAddressSuggestions(data.addressSuggestions, data.message);
    }
    
    if (data.errors) {
      Object.keys(data.errors).forEach(fieldName => {
        const input = document.getElementById(fieldName);
        const errorClass = getErrorClass(fieldName);
        const errorMessage = document.querySelector(`.${errorClass}`);

        if (input) input.classList.add('error');
        if (errorMessage) errorMessage.classList.add('showError');
      });
      return false;
    }
    
    await showAddressErrorDrawer(data.message || 'Impossible de valider l\'adresse');
    return false;
  } catch (error) {
    console.error('Erreur de validation:', error);
    return false;
  }
}

async function handleAddressSuggestions(suggestions, message) {
  return new Promise((resolve) => {
    const drawer = document.getElementById('address-suggestion-drawer');
    const title = document.getElementById('address-drawer-title');
    const messageEl = document.getElementById('address-drawer-message');
    const suggestionsList = document.getElementById('address-suggestions-list');
    const editBtn = document.getElementById('edit-address-btn');
    const confirmBtn = document.getElementById('confirm-address-btn');
    
    if (!drawer || !suggestionsList || !editBtn || !confirmBtn) {
      console.error('Éléments du drawer d\'adresse manquants');
      stopCartAnimation();
      resolve(false);
      return;
    }
    
    // Afficher le message
    if (title) title.textContent = 'Sélectionnez votre adresse';
    if (messageEl) messageEl.textContent = message || '';
    
    // Créer les options radio pour chaque suggestion
    suggestionsList.innerHTML = '';
    suggestions.forEach((suggestion, index) => {
      const optionDiv = document.createElement('div');
      optionDiv.className = 'form-control';
      optionDiv.style.cssText = 'padding: 12px; border: 1px solid rgb(var(--border-color)); border-radius: 4px; cursor: pointer;';
      
      const radioId = `address-option-${index}`;
      const radioInput = document.createElement('input');
      radioInput.type = 'radio';
      radioInput.name = 'address-selection';
      radioInput.id = radioId;
      radioInput.value = index;
      if (index === 0) radioInput.checked = true;
      
      const label = document.createElement('label');
      label.htmlFor = radioId;
      label.style.cssText = 'cursor: pointer; display: block; width: 100%;';
      label.innerHTML = `
        <strong>${suggestion.formatted || `${suggestion.street}, ${suggestion.postcode} ${suggestion.city}`}</strong>
        ${suggestion.description ? `<br><small style="color: rgb(var(--text-subdued));">${suggestion.description}</small>` : ''}
      `;
      
      optionDiv.appendChild(radioInput);
      optionDiv.appendChild(label);
      optionDiv.addEventListener('click', () => radioInput.checked = true);
      suggestionsList.appendChild(optionDiv);
    });
    
    const closeDrawer = (shouldContinue) => {
      cleanup();
      stopCartAnimation();
      drawer.hide();
      resolve(shouldContinue);
    };
    
    // Gérer le clic sur "Modifier mon adresse"
    const handleEdit = () => closeDrawer(false);
    
    // Gérer le clic sur "Valider cette adresse"
    const handleConfirm = async () => {
      const selectedRadio = document.querySelector('input[name="address-selection"]:checked');
      if (!selectedRadio) {
        alert('Veuillez sélectionner une adresse');
        return;
      }
      
      cleanup();
      
      const selectedAddress = suggestions[parseInt(selectedRadio.value)];
      
      // Mettre à jour les champs du formulaire
      document.getElementById('address_1').value = selectedAddress.street;
      document.getElementById('address_city').value = selectedAddress.city;
      document.getElementById('address_postal_code').value = selectedAddress.postcode;
      document.getElementById('address_country').value = selectedAddress.country;
      
      if (selectedAddress.building) {
        document.getElementById('address_2').value = selectedAddress.building;
        localStorage.setItem('address_2', selectedAddress.building);
      }
      
      drawer.hide();
      resolve(true);
    };
    
    const cleanup = () => {
      editBtn.removeEventListener('click', handleEdit);
      confirmBtn.removeEventListener('click', handleConfirm);
      drawer.removeEventListener('close', handleEdit);
    };
    
    editBtn.addEventListener('click', handleEdit);
    confirmBtn.addEventListener('click', handleConfirm);
    drawer.addEventListener('close', handleEdit);
    
    if (typeof drawer.show === 'function') drawer.show();
  });
}

async function showAddressErrorDrawer(message) {
  return new Promise((resolve) => {
    const drawer = document.getElementById('address-suggestion-drawer');
    const title = document.getElementById('address-drawer-title');
    const messageEl = document.getElementById('address-drawer-message');
    const suggestionsList = document.getElementById('address-suggestions-list');
    const editBtn = document.getElementById('edit-address-btn');
    const confirmBtn = document.getElementById('confirm-address-btn');
    
    if (!drawer) {
      console.error('Drawer d\'adresse manquant');
      stopCartAnimation();
      resolve(false);
      return;
    }
    
    // Afficher le message d'erreur
    if (title) title.textContent = 'Erreur de validation d\'adresse';
    if (messageEl) messageEl.textContent = message;
    if (suggestionsList) suggestionsList.innerHTML = '';
    if (confirmBtn) confirmBtn.style.display = 'none';
    
    const closeDrawer = () => {
      editBtn.removeEventListener('click', closeDrawer);
      drawer.removeEventListener('close', closeDrawer);
      if (confirmBtn) confirmBtn.style.display = '';
      stopCartAnimation();
      drawer.hide();
      resolve(false);
    };
    
    editBtn.addEventListener('click', closeDrawer);
    drawer.addEventListener('close', closeDrawer);
    
    if (typeof drawer.show === 'function') drawer.show();
  });
}

function getErrorClass(inputId) {
  const errorMap = {
    emailAddress: 'emailError',
    first_name: 'firstNameError',
    last_name: 'lastNameError',
    address_1: 'addressError',
    address_postal_code: 'postalCodeError',
    address_city: 'cityError',
    phone: 'phoneError'
  };
  return errorMap[inputId] || null;
}

async function checkoutRedirect(event) {
  event.preventDefault();
  event.stopPropagation();

  // Démarrer l'animation native du thème
  const cartBtn = document.querySelector('[type="submit"][name="cart"]');
  if (cartBtn) {
    cartBtn.setAttribute('aria-busy', 'true');
  }

  const isValid = await validateFields();
  if (!isValid) {
      // Arrêter l'animation native du thème
      if (cartBtn) {
        cartBtn.removeAttribute('aria-busy');
      }
      return; 
  }

  let subscription_discount = true
  // Redirection vers le checkout externe (secure.<domaine>/checkout) :
  //  - addShipProfile = true  → le client refuse l'abonnement → livraison payante (shipProfileId)
  //  - hasSubscriptionForRedirect = '1' → client déjà abonné → -50% sans produit RECURRING
  let addShipProfile = false;
  let hasSubscriptionForRedirect = '0';

  await saveShippingInfoToCart();

  const cartData = await fetchCartJS();
  const cartItems = cartData.items;

  const localePrefix = getLocalePrefix();

  if (cartData.attributes.originalCampaignId) {
    await addAttributeToCart("originalCampaignId", '43');
  }
  if (cartData.attributes.forceMerchantId) {
    await addAttributeToCart("forceMerchantId", '');
  }

  // Vérifier le sessionStorage subscription_active en premier
  const subscriptionActive = getSessionStorage('subscription_active');
  if (subscriptionActive === '1') {
    hasSubscriptionForRedirect = '1';
    await correctionNbAboDansLePanier(cartItems, 0);
    await addAttributeToCart("has_subscription", 1);
    await redirectionCheckout(cartData, false, hasSubscriptionForRedirect);
    return;
  }

  var emailAddress = $('#emailAddress').val();
  const subscriptionData = await verificationAbonnementActif(emailAddress);
  if (subscriptionData.success) {
    hasSubscriptionForRedirect = '1';
    await correctionNbAboDansLePanier(cartItems, 0);
    await addAttributeToCart("has_subscription", 1);
    await redirectionCheckout(cartData, false, hasSubscriptionForRedirect);
    return;
  }

  await addAttributeToCart("has_subscription", 0);

  let existingItem = cartItems.find(item => item.id === 55905898889547);
  if (existingItem) {
    if (existingItem.quantity > 1) {
      await correctionNbAboDansLePanier(cartItems, 1);
    }
    await redirectionCheckout(cartData, false, hasSubscriptionForRedirect);
    return;
  }

  // Arrêter l'animation native du thème à la fin
  if (cartBtn) {
    cartBtn.removeAttribute('aria-busy');
  }
  $('#HoverPopupUpsell').addClass('active');

  const ouiAbo = document.getElementById('ouiAbo');
  const nonAbo = document.getElementById('nonAbo');
  
  $('#ouiAbo').off('click').on('click', function () {
    
    // Démarrer l'animation native du thème
    ouiAbo.setAttribute('aria-busy', 'true');
    nonAbo.disabled = true;
    
    addProductToCart(55905898889547, 1).then(success => {
      if (success) {
        // Arrêter l'animation native du thème
        ouiAbo.removeAttribute('aria-busy');
        nonAbo.disabled = false;
        redirectionCheckout(cartData, false, hasSubscriptionForRedirect);
      } else {
        // Arrêter l'animation native du thème
        ouiAbo.removeAttribute('aria-busy');
        nonAbo.disabled = false;
        alert('Une erreur s\'est produite, veuillez réessayer');
        window.location.reload();
      }
    });
    return;
  });
  
  $('#nonAbo').off('click').on('click', function () {
    // Démarrer l'animation native du thème
    nonAbo.setAttribute('aria-busy', 'true');
    ouiAbo.disabled = true;
    redirectionCheckout(cartData, true, hasSubscriptionForRedirect);
    // Arrêter l'animation native du thème
    nonAbo.removeAttribute('aria-busy');
    ouiAbo.disabled = false;
    return;
  });
}

// Construit l'URL du checkout externe (secure.<domaine>/checkout) et y redirige.
// Reproduit le comportement des sites mediabuy, mais SANS passer par le
// load-balancing (atri.php) : ce Shopify Front est déjà la campagne de
// destination, donc les campaignProductId du panier sont les bons.
async function redirectionCheckout(cartData, addShipProfile, hasSubscriptionForRedirect = null) {
  const config = url_api_serveur();
  const localePrefix = getLocalePrefix();

  var cookie = getCartCookie('cart');

  const utm_source = getCartCookie('utm_source');
  const utm_campaign = getCartCookie('utm_campaign');
  const utm_term = getCartCookie('utm_term');
  const utm_content = getCartCookie('utm_content');
  let utms = '';
  if (utm_source) utms += `&utm_source=${utm_source}`;
  if (utm_campaign) utms += `&utm_campaign=${utm_campaign}`;
  if (utm_term) utms += `&utm_term=${utm_term}`;
  if (utm_content) utms += `&utm_content=${utm_content}`;

  var coupon = '';
  var storedCoupon = localStorage.getItem('discountCode');
  if (storedCoupon) {
    coupon = '&couponCode=' + storedCoupon;
  }

  const productMetaData = await getProductMetaData();

  // Produits au format "ID[||cle~valeur|...]:QTT" (l'ID encode déjà ".variantDetailId" pour les
  // produits variables). C'est exactement le format attendu par
  // parseProductsString() du checkout externe (checkout-Namae).
  var urlLineItems = productMetaData.meta_product_id_array.reduce(function (output, item) {
    // Double encodage : le serveur décode une fois, les valeurs ne doivent pas contenir ; : | & # en clair
    var propertiesString = Object.keys(item.properties || {}).map(function (key) {
      return encodeURIComponent(encodeURIComponent(key)) + '~' + encodeURIComponent(encodeURIComponent(item.properties[key]));
    }).join('|');
    return output.concat([item.id + (propertiesString ? '||' + propertiesString : '') + ':' + item.quantity]);
  }, []).join(';');

  let shippingData = {
    firstName: cartData.attributes.first_name || document.getElementById('first_name')?.value || '',
    lastName: cartData.attributes.last_name || document.getElementById('last_name')?.value || '',
    address1: cartData.attributes.address_1 || document.getElementById('address_1')?.value || '',
    address2: cartData.attributes.address_2 || document.getElementById('address_2')?.value || '',
    postalCode: cartData.attributes.address_postal_code || document.getElementById('address_postal_code')?.value || '',
    city: cartData.attributes.address_city || document.getElementById('address_city')?.value || '',
    country: cartData.attributes.address_country || document.getElementById('address_country')?.value || '',
    emailAddress: cartData.attributes.emailAddress || document.getElementById('emailAddress')?.value || '',
    phoneNumber: cartData.attributes.phone || document.getElementById('phone')?.value || ''
  };

  var urlParams =
    '&shipFirstName=' + encodeURIComponent(shippingData.firstName) +
    '&shipLastName=' + encodeURIComponent(shippingData.lastName) +
    '&shipAddress1=' + encodeURIComponent(shippingData.address1) +
    '&shipAddress2=' + encodeURIComponent(shippingData.address2) +
    '&shipPostalCode=' + encodeURIComponent(shippingData.postalCode) +
    '&shipCity=' + encodeURIComponent(shippingData.city) +
    '&shipCountry=' + encodeURIComponent(shippingData.country) +
    '&emailAddress=' + encodeURIComponent(shippingData.emailAddress) +
    '&phoneNumber=' + encodeURIComponent(shippingData.phoneNumber) +
    '&billShipSame=1' +
    '&campaignId=43';

  if (addShipProfile) {
    // Cas 3 : pas d'abonnement → livraison payante
    urlParams += '&shipProfileId=41';
  } else {
    // Cas 1 (produit RECURRING dans le panier) ou Cas 2 (déjà abonné → '1')
    const effectiveHasSubscription = hasSubscriptionForRedirect !== null
      ? String(hasSubscriptionForRedirect)
      : String((cartData.attributes && cartData.attributes.has_subscription) || '0');
    urlParams += '&has_subscription=' + encodeURIComponent(effectiveHasSubscription);
  }

  // Pixel(s) Facebook : même format que les sites mediabuy (pixelId:token;...)
  let pixelParams = [];
  if (Array.isArray(window.pixelConfigs) && window.pixelConfigs.length > 0) {
    window.pixelConfigs.forEach(({ pixelId, accessToken }) => {
      pixelParams.push(pixelId + ':' + accessToken);
    });
    if (pixelParams.length > 0) {
      urlParams += '&pixel=' + encodeURIComponent(pixelParams.join(';'));
    }
  }

  const checkoutBase = config.checkout_externe_api + localePrefix + '/checkout';
  if (typeof utm !== 'undefined' && utm) {
    window.location.href = checkoutBase + '?products=' + urlLineItems + '&cartId=' + cookie + urlParams + decodeURIComponent(utms) + coupon;
  } else {
    window.location.href = checkoutBase + '?products=' + urlLineItems + '&cartId=' + cookie + urlParams + coupon;
  }
}





document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('subscription-cancel-form');
  if (!form) return; // Sortir si le formulaire n'existe pas sur cette page
  
  const emailInput = document.getElementById('cancel_email_input');
  const nameInput = document.getElementById('cancel_customer_name');
  const reasonInput = document.getElementById('cancel_reason_text');
  
  // HoneyPot detection
  const honeypotField = document.getElementById('cancel_website_field');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    
    hideMessage('cancel-form-message');
    // Vérification HoneyPot - si le champ est rempli, c'est un bot
    if (honeypotField && honeypotField.value.trim() !== '') {
      console.warn('Bot détecté via HoneyPot');
      displayMessage('cancel-form-message', 'error', 'Erreur de validation. Veuillez réessayer.');
      return;
    }
    
    // Validation des champs
    const email = emailInput.value.trim();
    const customerName = nameInput.value.trim();
    const reason = reasonInput.value.trim();
    
    if (!email || !customerName || !reason) {
      displayMessage('cancel-form-message', 'error', 'Veuillez remplir tous les champs requis.');
      return;
    }
    
    // Validation email simple
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      displayMessage('cancel-form-message', 'error', 'Veuillez saisir une adresse e-mail valide.');
      return;
    }
    
    const cancelBtn = document.getElementById('cancel-submit-btn');

    // Préparer les données à envoyer
    const config = url_api_serveur();
    const localePrefix = getLocalePrefix();
    const language = localePrefix ? localePrefix.replace('/', '') : 'fr';
    
    let requestData = {
      email: email,
      customerName: customerName,
      reason: reason,
      language: language,
      timestamp: Date.now()
    };

    // Envoyer la requête
    fetch(config.cancel_subscription_api, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(requestData)
    })
    .then(response => {
      return response.text();
    })
    .then(text => {
      try {
        const data = parseLooseJSON(text);
        if (!data || typeof data !== 'object') {
          throw new Error('Invalid JSON response');
        }
        
        if (data.success) {
          displayMessage('cancel-form-message', 'success', data.message || 'Demande d\'annulation envoyée avec succès.');
          
          form.reset();
          
          sessionStorage.removeItem('customerData');
          sessionStorage.removeItem('subscription_active');
        } else {
          displayMessage('cancel-form-message', 'error', data.message || 'Une erreur est survenue lors du traitement de votre demande.');
        }
        
        // Arrêter l'animation native du thème
        if (cancelBtn) {
          cancelBtn.removeAttribute('aria-busy');
        }
      } catch (err) {
        console.error('Erreur de parsing JSON :', err);
        displayMessage('cancel-form-message', 'error', 'Réponse inattendue du serveur. Veuillez réessayer.');
        
        // Arrêter l'animation native du thème en cas d'erreur parsing
        if (cancelBtn) {
          cancelBtn.removeAttribute('aria-busy');
        }
      }
    })
    .catch(error => {
      console.error('Erreur réseau ou CORS :', error);
      // Arrêter l'animation native du thème en cas d'erreur réseau
      if (cancelBtn) {
        cancelBtn.removeAttribute('aria-busy');
      }
      displayMessage('cancel-form-message', 'error', 'Une erreur de connexion est survenue.');
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  $(document).on('click', '[type="submit"][name="cart"]', checkoutRedirect);
});
